var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    className: "q-icon",
    "aria-hidden": "true",
    role: "presentation",
    viewBox: "0 0 24 24",
    "data-v-5ea012e0": "",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "sensor-outline",
    width: "100%",
    height: "100%",
    viewBox: "0 0 128 128"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82,32a2,2,0,0,1,2,2V80a2,2,0,0,1-2,2H46a2,2,0,0,1-2-2V34a2,2,0,0,1,2-2H82m0-8H46A10,10,0,0,0,36,34V80A10,10,0,0,0,46,90H82A10,10,0,0,0,92,80V34A10,10,0,0,0,82,24Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.94,41.41a20.8,20.8,0,0,0,0,30.25,4.62,4.62,0,0,1-6.35,6.72,30,30,0,0,1,0-43.7,4.62,4.62,0,0,1,6.35,6.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.13,56.54a6.84,6.84,0,0,1,1.61-4.42,4.62,4.62,0,0,0-7.08-5.95,16.13,16.13,0,0,0,0,20.74A4.62,4.62,0,0,0,30.74,61a6.84,6.84,0,0,1-1.61-4.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.87,56.54a6.83,6.83,0,0,0-1.61-4.42,4.62,4.62,0,0,1,7.08-5.95,16.13,16.13,0,0,1,0,20.74A4.62,4.62,0,1,1,97.26,61a6.83,6.83,0,0,0,1.61-4.42Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.06,41.41a20.8,20.8,0,0,1,0,30.25,4.62,4.62,0,1,0,6.35,6.72,30,30,0,0,0,0-43.7,4.62,4.62,0,1,0-6.35,6.72Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,13a4,4,0,0,1,4,4v7.08H53V17a4,4,0,0,1,4-4H71m0-4H57a8,8,0,0,0-8,8V28.08H79V17a8,8,0,0,0-8-8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,90.08V111a4,4,0,0,1-4,4H57a4,4,0,0,1-4-4V90.08H75m4-4H49V111a8,8,0,0,0,8,8H71a8,8,0,0,0,8-8V86.08Z",
    transform: "translate(0 0)"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#sensor-outline",
    fill: "#525957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensor);
export default __webpack_public_path__ + "static/media/sensor.3960898c4b5128368751893af4eeabbb.svg";
export { ForwardRef as ReactComponent };